import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAssignMarketPlan extends Layout {
    sourceProspect: DataSource;
    sourceAssignMarketPlan: DataSource;
    sourceOpportunity: DataSource;
    sourceProspect: DataSource;
    textboxContact: Textbox;
    textboxCustomerMarkPlanId: Textbox;
    textboxCustomerStartDate: Textbox;
}
